// 'use client';
//
// import Lenis from 'lenis';
// import { usePathname } from 'next/navigation';
// import { useEffect } from 'react';
//
// const SmoothScroll: React.FC<{ children: React.ReactNode }> = ({
//   children,
// }) => {
//   const pathname = usePathname();
//   useEffect(() => {
//     if (pathname.includes('/blog-admin')) return;
//     const lenis = new Lenis({ duration: 1.8 });
//     function raf(time: number) {
//       lenis.raf(time);
//       requestAnimationFrame(raf);
//     }
//     requestAnimationFrame(raf);
//     return () => lenis.destroy();
//   }, [pathname]);
//
//   return <>{children}</>;
// };
// export default SmoothScroll;

'use client';

import Lenis from 'lenis';
import { usePathname } from 'next/navigation';
import { useLayoutEffect } from 'react';

const SmoothScroll: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const pathname = usePathname();

  useLayoutEffect(() => {
    if (pathname.includes('/blog-admin')) return;

    const navigation = window.performance.getEntriesByType(
      //added
      'navigation',
    )[0] as PerformanceNavigationTiming | undefined; //added

    const isBackForward = navigation?.type === 'back_forward'; //added

    const lenis = new Lenis({
      duration: 1.8,
    });
    (window as unknown as { appLenis?: Lenis }).appLenis = lenis;

    if (!isBackForward) {
      //added
      window.scrollTo(0, 0);
      lenis.scrollTo(0, { immediate: true }); //added
    }

    let animationFrame: number;

    function raf(time: number) {
      lenis.raf(time);
      animationFrame = requestAnimationFrame(raf);
    }

    animationFrame = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(animationFrame); //added
      delete (window as unknown as { appLenis?: Lenis }).appLenis;
      lenis.destroy();
    };
  }, [pathname]);

  return <>{children}</>;
};

export default SmoothScroll;
